<button class="tw-relative tw-h-6 tw-w-8 tw-cursor-pointer" [ngClass]="{ 'menu-open': isMenuOpen }">
  <i></i>
  <i></i>
  <i></i>
</button>
